import React from 'react';

// Navigation
import NavCrumbs from 'routes/dashboard/nav-crumbs';

export default function (props) {

  let { locationData } = props;

  let crumbs = [
        {name: 'Administration', path: 'administration'},
        {name: 'Locations', path: 'administration/locations'},
        {name: '...', path: '#'},
  ];

  if (locationData != null) {
    crumbs[2] =  { name: `${locationData.title}`, path: `administration/locations/${locationData._id}` }
  };

  return (
   <div>
       <NavCrumbs crumbs={crumbs} />
       {props.children}
   </div>
  )
}
